import React from "react";

const SignosPsicologia = ({signos, onChange, errors, disabled}) => {
    return <div className="col-md-12">
        <div className="form-group">
            <label>Estado emocional *</label>
            <select 
                value={signos.estado}
                onChange={e => onChange({estado: e.target.value})}
                className="form-control" 
                name="estado"
                disabled={disabled}
            >
                <option value="">Seleccionar...</option>
                <option value="Alegre">Alegre</option>
                <option value="Ansioso">Ansioso</option>
                <option value="Asustado">Asustado</option>
                <option value="Calmado">Calmado</option>
                <option value="Culpable">Culpable</option>
                <option value="Deprimido">Deprimido</option>
                <option value="Enojado">Enojado</option>
                <option value="Esperanzado">Esperanzado</option>
                <option value="Frustrado">Frustrado</option>
                <option value="Irritable">Irritable</option>
                <option value="Nervioso">Nervioso</option>
                <option value="Triste">Triste</option>
                <option value="Confiado">Confiado</option>
                <option value="Motivado">Motivado</option>
                <option value="Indiferente">Indiferente</option>
                <option value="Preocupado">Preocupado</option>
                <option value="Satisfecho">Satisfecho</option>
                <option value="Tenso">Tenso</option>
                <option value="Confundido">Confundido</option>
                <option value="Resignado">Resignado</option>
            </select>
            {errors['signos.estado'] && (
                <small className='help-blockParams form-Text'>
                    {errors['signos.estado'][0]}
                </small>
            )}
        </div>
    </div>;
};

export default SignosPsicologia;
